export const VACANCY = 'Вакансія';
export const VACANCY_SEARCH = 'Пошук вакансій';
export const NEW_VACANCY = 'Нова вакансія';
export const VACANCIES = 'Вакансії';
